import { isBrowser } from "src/utilities/env"

export function isCoarsePointer() {
  if (isBrowser) {
    return window.matchMedia("(pointer: coarse)").matches
  }
  return true
}
